/* eslint-disable no-console,no-undef,camelcase */
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";

import {
  Layout,
  Container,
  InputContainer,
  StyledInputV2,
  StyledLabel,
  ButtonContainer,
  EditorContainer,
  StyledInputV3,
} from "../CreateEvent/style";

import {  closeIcon, CloseIconBranding, PromotionalDocIcon, RecognitionCloseIcon, UploadHDMIcon, UploadIconSVG, WeekDropdownIcon, AddAudioVideoIcon, EditAudioVideoIcon } from "../../utils/icons";
import { CommonButtonPopup } from "../ReportsV2/styles";
import { CommonButtonBorder } from "../common/commonStyles";
import { Border } from "../Journeys/styles";
import { FormHeading } from "../ChallengeCreationAdmin/ActivityChallengeLaunch/style";
import { ManagerIconContainer } from "../Manager/styles";
import CommonImageUploaderFile from "../common/CommonImageUploader/CommonImageUploaderFile";
import Editor from "../CKEditor";
import { Main } from "../AdminTeamCreation/styles";
import StepsHeading from "../../components/RecogntionAdmin/corevalues/stepNames";
import CommonDropdown from "../common/CommonDropDown/CommonDropdown";
import { RadioButton, RadioButtonWrapper } from "../RecogntionAdmin/styles";
import { ActionButton, AudioUploadBox, } from  "../WellnessChallenge/styles";
import { WeekChipsRow, WeekChip, DayAccordionRow, WeekLabel, DayGrid, DayBox, DayNumber, DayBoxBottom, DayStatusBadge } from "./styles";
import UploadAudioVideoModal from "./UploadAudioVideoModal";
import { InputImage, RemoveImageV2, UploadPhotoContainer } from "../common/CommonImageUploader/style";
import { AddWellnessChallenge, AddWellnessChallengeLibraryStep1, AddWellnessChallengeLibraryStep2, AddWellnessChallengeLibraryStep3, AddWellnessChallengeLibraryStep4, ConvertCsvToJson, GetChallengeLevel, GetChallengesTasksById, GetWellbeingPillars } from "../../redux/constants/apiConstants";
import { legacyChallengeLength } from "../../../mockData";
import { toast } from "react-toastify";
import {  deleteFromS3, fetchApi, uploadToS3 } from "../../utils/methods";
import CSVList from "../PeopleHomeV2/CSVList";
import Waiting from "../Waiting";
// import { ImageUrl } from "../../utils/constants";
// import Spinner from "../common/Spinner";



const sampleData = [
  { week: 1, day: 1, goal: "Task 1", video_link: "https://example.com/video1", "task": "enter you task", "journalingNotification": "Notification for journaling goal", "notCompletedNotification": "Notification for not completed goal" },
  { week: 1, day: 2, goal: "Task 2", video_link: "https://example.com/video2", "task": "enter you task", "journalingNotification": "Notification for journaling goal", "notCompletedNotification": "Notification for not completed goal" },
  { week: 1, day: 3, goal: "Task 3", video_link: "https://example.com/video3", "task": "enter you task", "journalingNotification": "Notification for journaling goal", "notCompletedNotification": "Notification for not completed goal"  },
  { week: 1, day: 4, goal: "", video_link: "", "task": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 1, day: 5, goal: "", video_link: "" , "task": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 1, day: 6, goal: "", video_link: "" , "task": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 1, day: 7, goal: "", video_link: "" , "task": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 2, day: 1, goal: "", video_link: "" , "task": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 2, day: 2, goal: "", video_link: "" , "task": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 2, day: 3, goal: "", video_link: "" , "task": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 2, day: 4, goal: "", video_link: "" , "task": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 2, day: 5, goal: "", video_link: "" , "task": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 2, day: 6, goal: "", video_link: "" , "task": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 2, day: 7, goal: "", video_link: "" , "task": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 3, day: 1, goal: "", video_link: "" , "task": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 3, day: 2, goal: "", video_link: "" , "task": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 3, day: 3, goal: "", video_link: "" , "task": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 3, day: 4, goal: "", video_link: "" , "task": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 3, day: 5, goal: "", video_link: "" , "task": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 3, day: 6, goal: "", video_link: "" , "task": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 3, day: 7, goal: "", video_link: "" , "task": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 4, day: 1, goal: "", video_link: "" , "task": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 4, day: 2, goal: "", video_link: "" , "task": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 4, day: 3, goal: "", video_link: "" , "task": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 4, day: 4, goal: "", video_link: "" , "task": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 4, day: 5, goal: "", video_link: "" , "task": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 4, day: 6, goal: "", video_link: "" , "task": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 4, day: 7, goal: "", video_link: "" , "task": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 5, day: 1, goal: "", video_link: "" , "task": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 5, day: 2, goal: "", video_link: "" , "task": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 5, day: 3, goal: "", video_link: "" , "task": "", "journalingNotification": "", "notCompletedNotification": "" },
];

class CreateLegacyChallengeForm extends Component {
  constructor(props) {
    super(props);
    this.csvInputRef = React.createRef();
    this.state = {
      title: "",
      videoTitle: "",
      videoUrl: "",
      challenge_level: null,
      pointValue: "",
      url: "",
      pillar_Id: this.props.history.location?.state?.category_Id,
      categoryDescription:this.props.history.location?.state?.categoryDescription,
      options: ["", ""],
      activeQuestion: 0,
      feedbackActiveQuestion: 0,
      description: "",
      selectedLinkOption: 0,
      selectedJournalingOption: 0,
      imageName: "",
      imageNameThumbnail:"",
      selectedWellbeingPillar:null,
      challengeWeeksValue: null,
      challengeWeeksKey: null,
      imgThumbnail:"",
      audio: '',
      imgSrc: "",
      imageFile: null,
      library_id: null,
      primaryImgSrc: "",
      eliteImgSrc: "",
      classTypeKey: "",
      primaryImageName: "",
      eliteImageName: "",
      selectedValues: [],
      buttonstatus: false,
      step: 1,
      selectedChallengePoint: '',
      file: null,
      fileName: "",
      csvUpload: false,
      points: null,
      so: false,
      audioName: '',
      isVideoUrl: false,
      showBack: false,
      buttonClickScrollTop: false,
      so2: false,
      // levelOpen: true,
      question: "",
      levels: null,
      loading: false,
      so3: false,
      audio_link: "",
      iseventUrlMsg: "",
      coachName: '',
      levelNumber: null,
      wellbeingPillars: [],
      printSampleBiometricCSV: false,
      charCount: 0,
      selectedOption: 0,
      selectedAudioVideoOption: 0,
      onSiteCategories: [],
      getThemesValue: [],
      selectedCategory: null,
      questions: [
        { text: "", options: ["", ""], allowMultiple: false },
      ],
      feedBackQuestions: [
        { text: "", options: ["", ""], allowMultiple: false },
      ],
      themeId: null,
      active: false,
      expandedWeek: 0,
      expandedDay: null,
      weeksData: [],
      activeModalDay: null,
    };
  }



  componentDidMount() {

    this.getAllWellbeingPillars();
    if (this.props.history.location?.state?.category_Id) {
      this.setState({ pillar_Id: this.props.history.location?.state?.category_Id });
      this.GetChallengeLevelNumber();
    }

  
  }


  printAction = (bool) => {
    this.setState({ printSampleBiometricCSV: bool });
  }

  isUrl = (videoUrl) => {
    const UrlRegex = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/;
  
    // ✅ If empty → no error
    if (!videoUrl) {
      this.setState({
        isVideoUrl: false,
        iseventUrlMsg: "",
      });
      return;
    }
  
    if (UrlRegex.test(videoUrl)) {
      this.setState({
        isVideoUrl: true,
        iseventUrlMsg: "",
      });
    } else {
      this.setState({
        isVideoUrl: false,
        iseventUrlMsg: "Please enter valid URL",
      });
    }
  };



  getAllWellbeingPillars = async () => {
    try {
      const res = await fetchApi(GetWellbeingPillars , "GET");

      if (res.status === "success") {
        this.setState({wellbeingPillars:res?.data})
      } else {
        toast.error(res.data.message || "Something went wrong");

      }
    } catch (error) {
      window.console.error(error);
    }
  };


  toggleWeek = (weekIndex) => {
    this.setState((prevState) => ({
      expandedWeek: prevState.expandedWeek === weekIndex ? null : weekIndex
    }));
  };

  toggleDay = (dayIndex) => {
    this.setState((prevState) => ({
      expandedDay: prevState.expandedDay === dayIndex ? null : dayIndex
    }));
  };

  saveDayMedia = (weekIndex, dayIndex, data) => {
    this.setState((prevState) => {
      const weeksData = [...prevState.weeksData];
      weeksData[weekIndex][dayIndex] = {
        ...weeksData[weekIndex][dayIndex],
        media_type: data.media_type,
        media_link: data.media_link || "",
        video_link: data.video_link || "",
      };
      return { weeksData };
    });
  };



  onSelectPoints = (name) => {
    const numWeeks = name.value;
    const weeksData = Array.from({ length: numWeeks }, () =>
      Array.from({ length: 7 }, () => ({
        goal: "",
        video_link: "",
        media_type: "yes-no",
        media_link: "",
        task: "",
        journalingNotification: "",
        notCompletedNotification: "",
      }))
    );
    this.setState({
      selectedChallengePoint: name.value,
      challengeWeeksKey: name.key,
      challengeWeeksValue: name.value,
      weeksData,
      expandedWeek: 0,
      expandedDay: null,
    });
  }


  onChangeInput = (e) => {
    if (e.target.value.charAt(0) !== ' ') {
      this.setState({
        [e.target.name]: e.target.value,
      });
    }

    if (e.target.name === "videoUrl") {
      this.isUrl(e.target.value);
    }

  };



  onChangeInputDay = (weekIndex, dayIndex, field, value,uploadField,uploadFieldValue) => {
    this.setState((prevState) => {
      const weeksData = [...prevState.weeksData];


      if (field === "media_type") {
        weeksData[weekIndex][dayIndex] = {
          ...weeksData[weekIndex][dayIndex],
          media_type: value,
          [uploadField]:uploadFieldValue || false
        };
      } else {
        weeksData[weekIndex][dayIndex] = {
          ...weeksData[weekIndex][dayIndex],
          [field]: value,
          [uploadField]:uploadFieldValue || false
        };
      }
  
      return { weeksData };
    });
  };


  onChangeURL = (e) => {
    if (e.target.value.charAt(0) !== ' ') {
      this.setState({
        url: e.target.value,
      });
    }
  };
  
 

  onRemoveAudio=async (day) => {
    const url = day?.media_link;
  
    await deleteFromS3(url);
  
  }

  removePhoto = () => {
    this.setState({
      imgSrc: "",
      imageName: "",
    });
  };

  
  // onChange = (file, baseImage, imageName) => {
  //   window.console.log("file param:", file);        // is this a File object or base64?
  //   window.console.log("baseImage param:", baseImage);
  //   window.console.log("imageName param:", imageName);


  //   this.setState({
  //     imgSrc: baseImage,
  //     imageName: imageName,
  //     imageFile: file || null,
  //   });
  // }


  // onImageFileChange = (file, baseImage, imageName) => {
  //   this.setState({
  //     imgSrc: baseImage,
  //     imageName: imageName,
  //     imageFile: file,
  //   });
  // }



  onImageFileChange = (file, baseImage, imageName) => {
    window.console.log("onImageFileChange called");
    window.console.log("file:", file);
    window.console.log("file instanceof File:", file instanceof File);
    window.console.log("file size:", file?.size);
  
    this.setState({
      imgSrc: baseImage,
      imageName: imageName,
      imageFile: file,
    });
  }
  



  saveStep1 = async () => {
    const { title, description, imageFile } = this.state;
    this.setState({ loading: true });


    window.console.log("imageFile:", imageFile);
    window.console.log("imageFile instanceof File:", imageFile instanceof File);
    window.console.log("imageFile size:", imageFile?.size);
    window.console.log("imageFile name:", imageFile?.name);
    window.console.log("imageFile type:", imageFile?.type);
  
    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("image", imageFile);



    for (let [key, value] of formData.entries()) {
      window.console.log("FormData entry:", key, value);
    }
  
    try {
      const res = await fetchApi(AddWellnessChallengeLibraryStep1, "POST", formData);
      if (res?.status === "success") {
        this.setState({ library_id: res.data?.library_id, loading: false });
        this.updateStep(2);
      } else {
        toast.error(res?.data?.message || "Failed to save step 1");
        this.setState({ loading: false });
      }
    } catch (error) {
      toast.error("Something went wrong");
      this.setState({ loading: false });
    }
  };
  

  // saveStep1 = async () => {
  //   const { title, description, imageFile } = this.state;

   

  //   window.console.log("saveStep1 CALLED");        // is this printing?
  //   window.console.log("title:", title);
  //   window.console.log("imageFile instanceof File:", imageFile instanceof File);



  //   this.setState({ loading: true });

  //   const formData = new FormData();
  //   formData.append("title", title);
  //   formData.append("description", description);
  //   if (imageFile) formData.append("image", imageFile);

  //   try {
  //     const res = await fetchApi(AddWellnessChallengeLibraryStep1, "POST", formData);
  //     if (res?.status === "success") {
  //       this.setState({ library_id: res.data?.library_id, loading: false });
  //       this.updateStep(2);
  //     } else {
  //       toast.error(res?.data?.message || "Failed to save step 1");
  //       this.setState({ loading: false });
  //     }
  //   } catch (error) {
  //     toast.error("Something went wrong");
  //     this.setState({ loading: false });
  //   }
  // };

  saveStep2 = async () => {
    const { library_id, selectedWellbeingPillar, selectedLinkOption, audio_link, videoUrl, challengeWeeksValue, selectedJournalingOption } = this.state;
    this.setState({ loading: true });

    const payload = {
      library_id,
      pillar_id: selectedWellbeingPillar?.id,
      intro_media_type: selectedLinkOption === 0 ? "mp3" : "mp4",
      intro_media_link: selectedLinkOption === 0 ? audio_link : videoUrl,
      challenge_length: `${challengeWeeksValue}_week`,
      allow_daily_journal: selectedJournalingOption === 0,
    };

    try {
      const res = await fetchApi(AddWellnessChallengeLibraryStep2, "POST", payload);
      if (res?.status === "success") {
        this.setState({ loading: false });
        this.updateStep(3);
      } else {
        toast.error(res?.data?.message || "Failed to save step 2");
        this.setState({ loading: false });
      }
    } catch (error) {
      toast.error("Something went wrong");
      this.setState({ loading: false });
    }
  };

  saveStep3 = async () => {
    const { library_id, weeksData } = this.state;
    this.setState({ loading: true });

    const tasks = [];
    weeksData.forEach((week, weekIndex) => {
      week.forEach((day, dayIndex) => {
        tasks.push({
          week: weekIndex + 1,
          day: dayIndex + 1,
          task_goal: day.goal || "",
          task: day.task || "",
          journaling_prompt: day.journalingNotification || null,
          not_completed_notification: day.notCompletedNotification || null,
        });
      });
    });

    const payload = { library_id, tasks };

    try {
      const res = await fetchApi(AddWellnessChallengeLibraryStep3, "POST", payload);
      if (res?.status === "success") {
        await this.fetchTaskIds(library_id);
        this.setState({ loading: false });
        this.updateStep(4);
      } else {
        toast.error(res?.data?.message || "Failed to save step 3");
        this.setState({ loading: false });
      }
    } catch (error) {
      toast.error("Something went wrong");
      this.setState({ loading: false });
    }
  };

  fetchTaskIds = async (library_id) => {
    try {
      const res = await fetchApi(`${GetChallengesTasksById}/${library_id}?task_for=library`, "GET");
      if (res?.status === "success") {
        const tasksByWeek = res.data?.tasks_by_week || {};
        this.setState((prevState) => {
          const weeksData = prevState.weeksData.map((week, wIdx) =>
            week.map((day, dIdx) => {
              const weekKey = String(wIdx + 1);
              const dayKey = String(dIdx + 1);
              const taskData = tasksByWeek[weekKey]?.[dayKey];
              if (!taskData) return day;
              return {
                ...day,
                task_id: taskData.id,
                media_type: taskData.media_type || day.media_type,
                media_link: taskData.media_link || day.media_link,
              };
            })
          );
          return { weeksData };
        });
      }
    } catch {
      // non-blocking — task IDs just won't be available
    }
  };

  saveStep4 = async () => {
    const { library_id } = this.state;
    this.setState({ loading: true });
    try {
      const res = await fetchApi(`${AddWellnessChallengeLibraryStep4}/${library_id}`, "POST");
      if (res?.status === "success") {
        toast.success("Challenge created successfully!");
        this.setState({ loading: false });
        this.redirect();
      } else {
        toast.error(res?.data?.message || "Failed to create challenge");
        this.setState({ loading: false });
      }
    } catch (error) {
      toast.error("Something went wrong");
      this.setState({ loading: false });
    }
  };

  onThumbnailChange = (baseImage, imageName) => {
    this.setState({
      imgThumbnail: baseImage,
      imageNameThumbnail: imageName,
    });
  }



  onChangeSilverImage = (baseImage, imageName) => {
    this.setState({
      silverBadgeImgSrc: baseImage,
      silverBadgeImageName: imageName,
    });
  }

  prepareStep3Payload = () => {
    const { weeksData } = this.state;
  
    const tasks = [];
  
    weeksData.forEach((week, weekIndex) => {
      week.forEach((day, dayIndex) => {
        tasks.push({
          week: weekIndex + 1,
          day: dayIndex + 1,
          task: day.task || "",
          goal: day.goal || "",
          journaling_prompt: day.journalingNotification || "",
          not_completed_notification: day.notCompletedNotification || "",
          media_type: day.media_type || "yes-no",
          media_link:
            day.media_type === "mp4" ? day.video_link : day.media_type === "mp3"
              ? day.media_link || null
              : null,
          // media_thumbnail:
          //   day.media_type === "mp3"
          //     ? day.media_thumbnail || null
          //     : null,
        });
      });
    });
  
    return {
      "step-3": {
        tasks
      }
    };
  };


  prepareStepFourPayload = () => {
    const { questions } = this.state;

    return {
      "step-4": {
        has_pre_quiz: true, // or dynamic if you add a toggle
        pre_quiz_questions: questions.map((q, index) => ({
          question: q.text,
          order: index + 1,
          allow_multiple_respondents: q.allowMultiple,
          answers: q.options
            .filter((opt) => opt.trim() !== "") // remove empty options
            .map((opt) => ({ answer: opt }))
        }))
      }
    };
  };

  prepareStepFivePayload = () => {
    const { feedBackQuestions } = this.state;

    const validQuestions = feedBackQuestions.filter(
      (q) =>
        q.text.trim() !== "" &&
        q.options.some((opt) => opt.trim() !== "")
    );

    return {
      "step-5": {
        has_post_quiz: validQuestions.length > 0,
        post_quiz_questions: validQuestions.map((q, index) => ({
          question: q.text,
          order: index + 1,
          allow_multiple_respondents: q.allowMultiple,
          answers: q.options
            .filter((opt) => opt.trim() !== "") // remove empty options
            .map((opt) => ({ answer: opt }))
        }))
      }
    };
  };


  GetChallengeLevelNumber = async () => {
    const { pillar_Id } = this.state;
    let apiUrl = GetChallengeLevel + "/" + pillar_Id;
    try {
      const res = await fetchApi(apiUrl, "GET");

      if (res?.status === "success") {
        toast.success(res.data[0]);
        this.setState({ challenge_level: res.data.current_level });

      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      toast.error(error);
    }
  }



  saveChallengeDetails = () => {
    const {
      title,
      description,
      imgSrc,
      videoTitle,
      videoUrl,
      challenge_level,
      challengeWeeksValue,
      pillar_Id,
      audio_link
    } = this.state;
    this.setState({
      // buttonStatus: true,
      loading: true
    });


    const step3Payload = this.prepareStep3Payload();
    const step4Payload = this.prepareStepFourPayload();
    const step5Payload = this.prepareStepFivePayload();

    ChallengeData = {
      "step-1": {
        "pillar_id": pillar_Id,
        "title": title,
        "description": description,
        "image": imgSrc,
      },
      "step-2": {
        "intro_media_title": videoTitle,
        "intro_media_link": this.state.selectedLinkOption === 0 ? audio_link   : videoUrl,
        "intro_media_type": this.state.selectedLinkOption === 0 ? "mp3" : this.state.selectedLinkOption === 1 ? "mp4" : null,
        // "intro_video_thumbnail": "base64_encoded_thumbnail",
        "challenge_level": challenge_level,
        "points": challengeWeeksValue,
      },
      ...step3Payload,
      ...step4Payload,
      ...step5Payload,
    }
    this.PostCreateChallenge(ChallengeData);
  };


  PostCreateChallenge = async (payload) => {
    try {
      const res = await fetchApi(AddWellnessChallenge, "POST", payload);

      if (res?.status === "success") {
        const categoryData = this.props.history.location?.state?.categoryData;
        toast.success(res.data[0]);
        this.props.history.push({ pathname: `/company/challenges/challenge-category/${this.props.history.location?.state?.category_Id}`,state:{...categoryData} })
        // this.redirect()
        this.setState({
          // buttonStatus: false,
          loading: false
        });
      } else {
        toast.error(res.data.message);
        this.setState({
          // buttonStatus: false,
          loading: false
        });
      }
    } catch (error) {
      toast.error(error);
      this.setState({
        // buttonStatus: false,
        loading: false
      });
    }
  }


  onChangeDescription = (evt) => {
    const newContent = evt.getData();
    const trimmedString = newContent.replace(/\s|&nbsp;/g, "");
    trimmedString.length === 0 ||
      trimmedString.length === 7 ||
      trimmedString === "<p></p><p></p>"
      ? this.setState({ description: "" })
      : this.setState({ description: newContent });

    const plainText = newContent.replace(/<[^>]*>/g, "").trim();
    const currentLength = plainText.length;
    this.setState({ charCount: currentLength });
  };

  updateStep = (value) => {
    this.setState({ step: value, buttonClickScrollTop: true });
  };


  redirect = () => {
    this.props.history.goBack();
  }

  renderHeading = () => (
    <FormHeading color={"#184A61"}>
      <div className="close-icon" onClick={this.redirect}>
        <ManagerIconContainer isWidth={"32px"}>{RecognitionCloseIcon('#DA6C74')}</ManagerIconContainer>
      </div>
      Create Legacy Challenge
    </FormHeading>
  );



  stepOneForm = () => {
    const {
      description,
      step,
      charCount,
    } = this.state;

    const { t } = this.props;

    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container color="#005C87">
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="legacy-challenge" />
            </div>
            <div className="form">

              <div className="formBody">

                <InputContainer>
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>{this.props.t("Title of the challenge")}{<span>*</span>}</StyledLabel>
                  <StyledInputV2
                    placeholder={this.props.t("Enter challenge title")}
                    name="title"
                    onChange={this.onChangeInput}
                    value={this.state.title}
                    maxLength="50"
                    style={{ background: "white" }}
                    pColor={"#BDBDBD"}
                    color="#184A61"
                    border={"1px solid #BDBDBD"}
                  />
                  <div className="count">{this.state.title?.length}/50 | C</div>
                </InputContainer>

                <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px', display: "flex" }} />

                <div style={{ display: "flex", gap: "12px" }}>
                  <div>
                    <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" marginb="12px" symbolSize={"14px"}>{this.props.t("Challenge image")}<span className="subtext">{("(Size limit up to 2 MB)")}</span>{<span>*</span>}</StyledLabel>
                    <CommonImageUploaderFile
                      imgSrc={this.state.imgSrc}
                      t={t}
                      closeIcon={closeIcon}
                      UploadIcon={UploadHDMIcon}
                      // onFileChange={this.onChange}
                      onFileChange={this.onImageFileChange}
                      onRemoveImage={this.removePhoto}
                      isMaxSize={true}
                      isText={"(.jpeg, .png) (1920px * 1080px)"}
                    />
                  </div>

                </div>
                <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px' }} />

                <InputContainer isColorError={charCount > 3000 ? true : false}>
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>{this.props.t("About the challenge")}</StyledLabel>
                  <EditorContainer>
                    <Editor content={description} placeholder={"Enter challenge description"} onChange={this.onChangeDescription} />
                  </EditorContainer>
                  <div className="char-count">{charCount}/3000 | C</div>
                </InputContainer>
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };

  toggleRadioButton = (value) => {
    this.setState({ selectedOption: value }, () => { });
  };


  toggleLinkRadioButton = (value) => {
    this.setState({ selectedLinkOption: value }, () => { });
  };




  toggleJournalingRadioButton = (value) => {
    this.setState({ selectedJournalingOption : value }, () => { });
  };



  toggleAudioVideoRadioButton = (value) => {
    this.setState({ selectedAudioVideoOption: value }, () => { });
  };



  onDropDownSelect = (key, item) => {
    this.setState({
      [key]: item
    });
  };

  onDropDownSelectCoach = (name, id, value) => {
    this.setState({
      [name]: id,
      coachName: value
    });
  };



  onSelectTheme = (item) => {
    this.setState({selectedWellbeingPillar:item});
  };

  stepTwoForm = () => {
    const {
      step,
      challengeWeeksValue,
      challengeWeeksKey,
      iseventUrlMsg,
      selectedLinkOption,
      selectedJournalingOption,
      audio_link,
      wellbeingPillars,
      selectedWellbeingPillar,
      so


    } = this.state;



    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container color="#005C87" >
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="legacy-challenge" />
            </div>
            <div className="form">
              <div className="formBody" >

                <CommonDropdown
                  tileContainerStyle={{ width: '100%', padding: '0px 0px 8px 0px'}}
                  dropdownStyle={{ top: '90px', zIndex: 10 }}
                  labelText={('Select Wellbeing Pillar')}
                  dropdownOpen={this.state.so}
                  placeholder={('Select Pillar')}
                  title={(selectedWellbeingPillar?.pillar_title) ?   selectedWellbeingPillar?.pillar_title :('Select theme')}
                  id="dropdown-theme"
                  onClick={() => this.setState({ so: !so })}
                  data={wellbeingPillars}
                  onSelect={this.onSelectTheme}
                  onSelectParameter={['pillar_title','id']}
                  itemValue
                  valueIndex={0}
                  valueString=""
                  dropIcon
                  labelMargin={"0px"}
                  isRequired={true}
                />

                <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px', display: "flex" }} />

                <div className="radioButtonDiv" style={{marginBottom:"12px"}}>
                  <RadioButtonWrapper isMargin="0px" width gap>
                    <div className="RadioButtonContainer">
                      <RadioButton
                        type={"radio"}
                        checked={selectedLinkOption === 0}
                        onChange={() => this.toggleLinkRadioButton(0)}
                        value={0}
                        id="1"
                      />
                      <div className="label">{"Upload Intro Audio"}</div>
                    </div>
                    <div className="RadioButtonContainer">
                      <RadioButton
                        type={"radio"}
                        checked={selectedLinkOption === 1}
                        onChange={() => this.toggleLinkRadioButton(1)}
                        value={1}
                        id="1"
                      />
                      <div className="label">{"Upload Intro Video"}</div>
                    </div>
                  </RadioButtonWrapper>
                </div>



                { selectedLinkOption === 0 ?  audio_link ? (
                  <>
                    <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>{this.props.t("Add Audio file")}</StyledLabel>
                    <UploadPhotoContainer showBorder={false}>
                      <div className="innerDivImageContainer">
                        <RemoveImageV2>
                          <div className="uploadImage">
                            <div className="promotional-doc">
                              <div className="promotional-doc-icon">
                                {PromotionalDocIcon()}
                              </div>
                              <div>
                                <span className="promotional-doc-name">
                                  Audio uploaded successfully!
                                </span>
                              </div>
                            </div>
                  
                            <div className="main-div" onClick={this.onRemoveAudioLink}>
                              <div className="icon-div">
                                <div className="sub-icon-div">
                                  {CloseIconBranding("#DA6C74", "8", "8")}
                                </div>
                              </div>
                            </div>
                          </div>
                        </RemoveImageV2>
                      </div>
                    </UploadPhotoContainer>
                  </>
                ) : (
                  <>
                    <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>{this.props.t("Add Audio file")}</StyledLabel>
                    <AudioUploadBox>
                      <div style={{ marginBottom: "8px" }}>
                        <UploadIconSVG />
                      </div>
                      <div style={{ color: "#184A61", fontWeight: "bold" }}>
                        Upload Audio
                      </div>
                      <div style={{ color: "#666", fontSize: "12px" }}>
                        (.mp3)
                      </div>
                      <input
                        type="file"
                        accept=".mp3,audio/mpeg"
                        onChange={this.onChangeAudioLink}
                      />
                    </AudioUploadBox>
                  </>
                ) : null}



                {selectedLinkOption === 1 ?  <>
                  <InputContainer>
                    <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>{this.props.t("Introduction Video Title")}</StyledLabel>
                    <StyledInputV2
                      placeholder={this.props.t("Enter title")}
                      name="videoTitle"
                      onChange={this.onChangeInput}
                      value={this.state.videoTitle}
                      maxLength="30"
                      style={{ background: "white" }}
                      pColor={"#BDBDBD"}
                      color="#184A61"
                      border={"1px solid #BDBDBD"}
                    />
                  </InputContainer>
  
                  <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px', display: "flex" }} />
                  <InputContainer>
                    <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>{this.props.t("Introduction Video")}</StyledLabel>
                    <StyledInputV2
                      placeholder={this.props.t("Enter URL")}
                      name="videoUrl"
                      onChange={this.onChangeInput}
                      value={this.state.videoUrl}
                      maxLength="30"
                      style={{ background: "white" }}
                      pColor={"#BDBDBD"}
                      color="#184A61"
                      border={"1px solid #BDBDBD"}
                    />
                    <span style={{ color: "#DA6C74", fontFamily: "Lato", fontSize: '12px' }}>{iseventUrlMsg}</span>
                  </InputContainer>

                </>:null}


               

                <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px', display: "flex" }} />
               

                <CommonDropdown
                  tileContainerStyle={{ width: "100%", padding: "0px 0px 8px 0px" }}
                  dropdownStyle={{ top: "90px" }}
                  labelText={("Challenge Length")}
                  dropdownOpen={this.state.so}
                  placeholder={("Select no. of weeks")}
                  // title={challengePointKey=="0 Points"?"No Points":challengePointKey ? (challengePointKey) : ("Select point")}
                  title={
                    challengeWeeksKey
                  }
                  id="dropdown-recurring"
                  onClick={() => this.setState({ so: !this.state.so })}
                  data={legacyChallengeLength}
                  onSelect={this.onSelectPoints}
                  active={challengeWeeksValue}
                  itemValue={true}
                  onSelectParameter={["value", "key"]}
                  // onSelectParameter={["month", "id", "theme_icon"]}
                  dropIcon={true}
                  valueIndex={1}
                  labelMargin={"0px"}
                  fontSize={"14px"}
                  isRequired={true}
                />


                <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px', display: "flex" }} />

                <InputContainer>
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>{this.props.t("Enable journaling for participants during this challenge?")}</StyledLabel>
                  <div className="radioButtonDiv" style={{marginBottom:"12px"}}>
                    <RadioButtonWrapper isMargin="0px" width gap>
                      <div className="RadioButtonContainer">
                        <RadioButton
                          type={"radio"}
                          checked={selectedJournalingOption === 0}
                          onChange={() => this.toggleJournalingRadioButton(0)}
                          value={0}
                          id="1"
                        />
                        <div className="label">{"Yes"}</div>
                      </div>
                      <div className="RadioButtonContainer">
                        <RadioButton
                          type={"radio"}
                          checked={selectedJournalingOption === 1}
                          onChange={() => this.toggleJournalingRadioButton(1)}
                          value={1}
                          id="1"
                        />
                        <div className="label">{"No"}</div>
                      </div>
                    </RadioButtonWrapper>
                  </div>
                </InputContainer>
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };




  handleFiles = (e) => {
    this.setState({
      file: "",
      fileName: "",
      csvUpload: false,
    });

    let file = e.target.files[0];
    if (!file) return;

    const fileName = file?.name;
    let checkCSV = fileName.split(".");
    if (checkCSV[checkCSV.length - 1].toLowerCase() !== "csv") {
      toast.error("Please select .csv format only");
      document.getElementById("csv-upload-input").value = "";
      return;
    }

    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      this.setState({
        file: reader.result ? reader.result : "data:",
        fileName: fileName,
        csvUpload: true,
      }, () => {
        // ✅ Once state is set, immediately call your API
        this.PostCsvToJson();
      });
    };
  };





  PostCsvToJson = async () => {
    const { file, challengeWeeksValue } = this.state;
    const numWeeks = challengeWeeksValue || 5;
    // const expectedRows = numWeeks * 7;

    const payload = { csv_base64: file };

    try {
      const res = await fetchApi(ConvertCsvToJson, "POST", payload);

      

      if (res?.status === "success") {
        toast.success(res.data.message);

        // const totalRows = res.data.total_rows;
        const data = res.data.data;

        const weeksData = Array.from({ length: numWeeks }, () =>
          Array.from({ length: 7 }, () => ({
            goal: "",
            video_link: "",
            media_type: "yes-no",
            media_link: "",
            task: "",
            journalingNotification: "",
            notCompletedNotification: "",
          }))
        );

        data.forEach((item) => {
          const wIndex = item.week - 1;
          const dIndex = item.day - 1;

          if (!weeksData[wIndex] || !weeksData[wIndex][dIndex]) return;

          const mediaType = item?.video_link ? "mp4" : "yes-no";

          const taskValue = (item?.todays_task ?? item?.task ?? "").toString().trim();
          const goalValue = (item?.todays_goal ?? item?.goal_based_notification ?? item?.goal ?? "").toString().trim();

          weeksData[wIndex][dIndex] = {
            task: taskValue,
            goal: goalValue,
            media_type: mediaType,
            video_link: item?.video_link ?? "",
            media_link: "",
            journalingNotification: item?.journaling_prompt_notification ?? "",
            notCompletedNotification: item?.not_completed_notification ?? "",
          };
        });

        // if (totalRows < expectedRows) {
        //   toast.error(
        //     `Uploaded CSV is incomplete. Please ensure all ${expectedRows} days are filled before uploading.`
        //   );
        //   return;
        // } else if (totalRows > expectedRows) {
        //   toast.error(
        //     `Uploaded CSV has more rows than required. Please ensure exactly ${expectedRows} days are filled.`
        //   );
        //   return;
        // }

        const hasEmptyTask = weeksData.some((week) =>
          week.some((day) => !day.task || day.task.trim() === "")
        );

        if (hasEmptyTask) {
          toast.error("Uploaded CSV is incomplete. Please ensure all days are filled before uploading.");
        }

        this.setState({ weeksData, expandedWeek: 0, expandedDay: null });
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    }
  };




  removeFile = () => {
    // Reset file input field
    const fileInput = document.getElementById('new-employee-file');
    if (fileInput) {
      fileInput.value = '';
    }

    // Reset state
    this.setState({
      csvUpload: false,
      fileName: '',
      file: ''
    });
  };

  onChangeAudioLink = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
  
    // ✅ Validation
    if ((file.size / 1000000) > 10) {
      return toast.error("Max 10MB");
    }
  
    if (file.type !== "audio/mpeg") {
      return toast.error("Only MP3 allowed");
    }
  
    // ✅ Show loader
    this.setState({ audioUploadLoading: true });
  
    const reader = new FileReader();
    reader.readAsDataURL(file);
  
    reader.onloadend = async () => {
      try {
        const s3Url = await uploadToS3(
          reader.result,
          `wellness/challenges/media`
        );
  
        if (s3Url?.path) {
          this.setState({
            audio_link: s3Url.path,
            media_type: "mp3",
            audioUploadLoading: false,
          });
        } else {
          this.setState({
            audio_link: "",
            audioUploadLoading: false,
          });
          toast.error("Upload failed");
        }
      } catch (error) {
        console.error(error);
        this.setState({ audioUploadLoading: false });
        toast.error("Something went wrong");
      }
    };
  };


  onRemoveAudioLink = async () => {
    const { audio_link } = this.state;
  
    try {
      if (audio_link) {
        await deleteFromS3(audio_link);
      }
  
      this.setState({
        audio_link: "",
        media_type: "",
      });
    } catch (error) {
      console.error(error);
    }
  };



  removeAudio = (e) => {
    e.preventDefault();
    this.setState({ audio: '', audioName: '' });
  };


  onChangeAudio = async (e, weekIndex, dayIndex) => {
    const file = e.target.files[0];
    if (!file) return;
  
    if ((file.size / 1000000) > 10) {
      return toast.error("Max 10MB");
    }
  
    if (file.type !== "audio/mpeg") {
      return toast.error("Only MP3 allowed");
    }
  
    const reader = new FileReader();
    reader.readAsDataURL(file);
  
    reader.onloadend = async () => {
      this.setState((prevState) => {
        const weeksData = [...prevState.weeksData];
    
        weeksData[weekIndex][dayIndex] = {
          ...weeksData[weekIndex][dayIndex],
          audioUploadLoading:true
        };
    
        return { weeksData };
      });

      const s3Url = await uploadToS3(reader.result, `wellness/challenges/media`);
  
      if (s3Url?.path) {
        this.onChangeInputDay(weekIndex, dayIndex, "media_link", s3Url?.path,"audioUploadLoading", false);
      }else{
        this.onChangeInputDay(weekIndex, dayIndex, "media_link", null,"audioUploadLoading", false);
      }
    };
  };


  getCSVHeaders = () => {
    const csvHeaders = [
      { label: "Week", key: "week" },
      { label: "Day", key: "day" },
      { label: "Today's Goal", key: "goal" },
      { label: "Today's Task", key: "task" },
      { label: "Journaling Prompt Notification", key: "journalingNotification" },
      { label: "Not Completed Notification", key: "notCompletedNotification" },
      { label: "Video Link", key: "video_link" },
    ];
    return csvHeaders;
  };



  stepThreeForm = () => {

    const {
      step,
      selectedOption,
      fileName,
      csvUpload,
      printSampleBiometricCSV,
      challengeWeeksValue,
      expandedWeek,
      expandedDay,
      weeksData,
      selectedJournalingOption,
    } = this.state;
    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container color="#005C87">
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="legacy-challenge" />
            </div>
            <div className="form">
              <div className="formBody">
                <StyledLabel isFont={"14px"} color={"#184A61"} marginb="12px" margin="0px">
                  {this.props.t("How would you like to add challenge goal")}{<span>*</span>}
                </StyledLabel>
                <div className="radioButtonDiv">
                  <RadioButtonWrapper isMargin="0px" width gap>
                    <div className="RadioButtonContainer">
                      <RadioButton
                        type={"radio"}
                        checked={selectedOption === 0}
                        onChange={() => this.toggleRadioButton(0)}
                        value={0}
                        id="1"
                      />
                      <div className="label">{"CSV upload"}</div>
                    </div>
                    <div className="RadioButtonContainer">
                      <RadioButton
                        type={"radio"}
                        checked={selectedOption === 1}
                        onChange={() => this.toggleRadioButton(1)}
                        value={1}
                        id="1"
                      />
                      <div className="label">{"Manual upload"}</div>
                    </div>
                  </RadioButtonWrapper>
                </div>

                {selectedOption === 0 ? <>
                  <Border style={{ background: '#EFEFEF', margin: '4px 0px' }} />
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" marginb="12px" symbolSize={"14px"}>{this.props.t("Add CSV document")}{<span>*</span>}</StyledLabel>
                  <UploadPhotoContainer showBorder={false}>
                    <div className="innerDivImageContainer">
                      {csvUpload ? (
                        <RemoveImageV2>
                          <div className="uploadImage">
                            <div className="promotional-doc">
                              <div className="promotional-doc-icon">{PromotionalDocIcon()}</div>
                              <div>
                                <span
                                  className="promotional-doc-name"
                                  title={fileName}
                                >
                                  {fileName}
                                </span>
                              </div>
                            </div>
                            <div className="main-div" onClick={this.removeFile}>
                              <div className="icon-div">
                                <div className="sub-icon-div">
                                  {CloseIconBranding("#F37A65", "8", "8")}
                                </div>
                              </div>
                            </div>
                          </div>
                        </RemoveImageV2>
                      ) : (
                        <div className="uploadImage">
                          <InputImage
                            className="edit-profile-pic"
                            imageReload={1}
                            style={{ background: "unset", color: "#184A61" }}
                          >
                            <div
                              className="middle-section"
                              onClick={() => this.csvInputRef.current.click()}
                            >
                              <div>{UploadHDMIcon()}</div>
                              <div className="title">{("Upload File")}</div>
                              <div className="sub-title">{("(.csv)")}</div>
                            </div>
                            <input
                              className="input-section"
                              id="csv-upload-input"
                              type="file"
                              accept=".csv"
                              multiple={false}
                              onChange={this.handleFiles}
                              ref={this.csvInputRef}
                              style={{ display: "none" }}
                            />
                          </InputImage>
                        </div>
                      )}
                    </div>
                  </UploadPhotoContainer>
                </> : null}

                {selectedOption === 0 && !csvUpload ? <ActionButton
                  onClick={() => this.setState({ printSampleBiometricCSV: true })}>
                  Download Sample
                </ActionButton> : null}
                {/* <Border style={{ background: '#EFEFEF', margin: '8px 0px' }} /> */}

                {(csvUpload && selectedOption === 0) || selectedOption === 1 ? (
                  <div style={{ marginTop: "20px" }}>
                    {/* Week chips */}
                    <WeekChipsRow>
                      {Array.from({ length: challengeWeeksValue || 0 }, (_, i) => (
                        <WeekChip
                          key={i}
                          active={expandedWeek === i}
                          onClick={() => this.setState({ expandedWeek: i, expandedDay: null })}
                        >
                          Week {i + 1}
                        </WeekChip>
                      ))}
                    </WeekChipsRow>

                    {/* Day accordion for selected week */}
                    {weeksData[expandedWeek] && weeksData[expandedWeek].map((day, dayIndex) => (
                      <React.Fragment key={dayIndex}>
                        <Border style={{ background: "#EFEFEF", margin: "0px" }} />
                        <DayAccordionRow onClick={() => this.toggleDay(dayIndex)}>
                          <span className="day-label">Day {dayIndex + 1}</span>
                          <div style={{ transform: expandedDay === dayIndex ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.3s" }}>
                            {WeekDropdownIcon("#DA6C74")}
                          </div>
                        </DayAccordionRow>



                        {expandedDay === dayIndex && (
                          <div style={{ paddingBottom: "8px" }}>
                            <InputContainer>
                              <StyledLabel isFont="14px" color="#184A61" margin="0px">
                                {this.props.t("Today's Goal")}<span>*</span>
                              </StyledLabel>
                              <StyledInputV3
                                rows={1}
                                placeholder={this.props.t("Enter Goal")}
                                value={day.goal}
                                onChange={(e) => {
                                  this.onChangeInputDay(expandedWeek, dayIndex, "goal", e.target.value);
                                  e.target.style.height = "auto";
                                  e.target.style.height = `${e.target.scrollHeight}px`;
                                }}
                                maxLength="100"
                                style={{ background: "white", overflow: "hidden" }}
                                pColor="#BDBDBD"
                                color="#184A61"
                                border="1px solid #BDBDBD"
                              />
                              <div className="count">{day.goal.length}/100 | C</div>
                            </InputContainer>

                            <Border style={{ background: "#EFEFEF", margin: "20px 0 8px 0px" }} />

                            <InputContainer>
                              <StyledLabel margin="0px">{this.props.t("Today’s Task")}<span>*</span> </StyledLabel>
                              <StyledInputV2
                                placeholder={this.props.t("Enter Task")}
                                value={day.task}
                                onChange={(e) => this.onChangeInputDay(expandedWeek, dayIndex, "task", e.target.value)}
                                maxLength="600"
                                style={{ background: "white" }}
                                pColor="#BDBDBD"
                                color="#184A61"
                                border="1px solid #BDBDBD"
                              />
                              <div className="count">{day.task?.length}/600 | C</div>
                            </InputContainer>

                            {selectedJournalingOption === 0 && (
                              <>
                                <Border style={{ background: "#EFEFEF", margin: "20px 0 8px 0px", display: "flex" }} />
                                <InputContainer>
                                  <StyledLabel isFont="14px" color="#184A61" margin="0px" symbolSize="14px">{this.props.t("Notification")} <span className="subtext">(Journaling Prompt)</span></StyledLabel>
                                  <StyledInputV2
                                    placeholder={this.props.t("Enter Prompt")}
                                    value={day.journalingNotification}
                                    onChange={(e) => this.onChangeInputDay(expandedWeek, dayIndex, "journalingNotification", e.target.value)}
                                    maxLength="100"
                                    style={{ background: "white" }}
                                    pColor="#BDBDBD"
                                    color="#184A61"
                                    border="1px solid #BDBDBD"
                                  />
                                  <div className="count">{day.journalingNotification?.length}/100 | C</div>
                                </InputContainer>
                              </>
                            )}

                            <Border style={{ background: "#EFEFEF", margin: "20px 0 8px 0px", display: "flex" }} />

                            <InputContainer>
                              <StyledLabel isFont="14px" color="#184A61" margin="0px" symbolSize="14px">{this.props.t("Today's Notification")} <span className="subtext">(If the task is not completed this notification will be sent to user)</span></StyledLabel>
                              <StyledInputV2
                                placeholder={this.props.t("Enter Notification")}
                                value={day.notCompletedNotification}
                                onChange={(e) => this.onChangeInputDay(expandedWeek, dayIndex, "notCompletedNotification", e.target.value)}
                                maxLength="100"
                                style={{ background: "white" }}
                                pColor="#BDBDBD"
                                color="#184A61"
                                border="1px solid #BDBDBD"
                              />
                              <div className="count">{day.notCompletedNotification?.length}/100 | C</div>
                            </InputContainer>

                            {/* <Border style={{ background: "#EFEFEF", margin: "20px 0 8px 0px", display: "flex" }} /> */}
                          </div>
                        )}
                      </React.Fragment>
                    ))}
                  </div>
                ) : null}
              </div>
            </div>
          </Container>
        </div>
        {printSampleBiometricCSV && <CSVList Title={`${"Sample file"}`} removeCSVData={this.printAction} headers={this.getCSVHeaders()} data={sampleData} />}
      </Layout>
    )
  }


 
  stepFourForm = () => {
    const { step, challengeWeeksValue, challengeWeeksKey, activeModalDay, weeksData } = this.state;
    const totalDays = (challengeWeeksValue || 0) * 7;

    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container color="#005C87" isFormPadding={"32px"}>
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="legacy-challenge" />
            </div>
            <div className="form">
              <div className="formBody">
                {challengeWeeksKey && (
                  <WeekLabel>{challengeWeeksKey}</WeekLabel>
                )}
                <DayGrid>
                  {Array.from({ length: totalDays }, (_, i) => {
                    const weekIndex = Math.floor(i / 7);
                    const dayIndex = i % 7;
                    const dayData = weeksData[weekIndex]?.[dayIndex] || {};
                    const mediaType = dayData.media_type;
                    const hasMedia = mediaType === "mp3" || mediaType === "mp4";
                    const badgeLabel =
                      mediaType === "mp4" ? "Video" :
                        mediaType === "mp3" ? "Audio" :
                          "Yes/No";
                    return (
                      <DayBox key={i}>
                        <DayNumber>{i + 1}</DayNumber>
                        <DayBoxBottom>
                          <DayStatusBadge mediaType={mediaType}>
                            <span>{badgeLabel}</span>
                          </DayStatusBadge>
                          <div
                            style={{ cursor: "pointer" }}
                            onClick={() => this.setState({ activeModalDay: { weekIndex, dayIndex } })}
                          >
                            {hasMedia ? EditAudioVideoIcon() : AddAudioVideoIcon()}
                          </div>
                        </DayBoxBottom>
                      </DayBox>
                    );
                  })}
                </DayGrid>
              </div>
            </div>
          </Container>
        </div>

        <UploadAudioVideoModal
          show={!!activeModalDay}
          onClose={() => this.setState({ activeModalDay: null })}
          onSave={this.saveDayMedia}
          weekIndex={activeModalDay?.weekIndex}
          dayIndex={activeModalDay?.dayIndex}
          libraryId={this.state.library_id}
          taskId={activeModalDay ? weeksData[activeModalDay.weekIndex]?.[activeModalDay.dayIndex]?.task_id : undefined}
          initialData={
            activeModalDay
              ? weeksData[activeModalDay.weekIndex]?.[activeModalDay.dayIndex]
              : null
          }
        />
      </Layout>
    );
  };


  // };


  isNextDisabled = () => {
    const { weeksData } = this.state;
  
    return weeksData.some((week) =>
      week.some((day) => {
        const task = typeof day.task === "string" ? day.task : "";
        return task.trim() === "";
      })
    );
  };

 
  isStepFourNextDisabled = () => {
    const { questions } = this.state;

    return questions.some((q) => {
      const filledOptions = q.options.filter((opt) => opt.trim() !== "");
      return filledOptions.length < 2 || q.text.trim() === "";
    });
  };


  isStepFiveNextDisabled = () => {
    const { feedBackQuestions } = this.state;
  
    return feedBackQuestions.some((q) => {
      const hasQuestion = q.text && q.text.trim() !== "";
  
      const filledOptions = q.options.filter(
        (opt) => opt && opt.trim() !== ""
      );
  
      const hasAnyOption = filledOptions.length > 0;
  
      if (!hasQuestion && !hasAnyOption) {
        return false;
      }
  
      if (hasQuestion && filledOptions.length < 2) {
        return true;
      }
  
      if (!hasQuestion && hasAnyOption) {
        return true;
      }
  
      return false;
    });
  };




  
  
  

  render() {
    const {
      imgSrc,
      charCount,
      step,
      title,
      loading,
      selectedLinkOption,
      selectedJournalingOption,
      challengeWeeksKey,
    } = this.state;

    if (loading) {
      return <Waiting />;
    }

    const isStep2Disabled =
      !challengeWeeksKey ||
      selectedLinkOption === null ||
      selectedLinkOption === undefined ||
      selectedJournalingOption === null ||
      selectedJournalingOption === undefined;

    // const isDisabled = !goldBadgeImgSrc || !silverBadgeImgSrc|| !bronzeBadgeImgSrc;

    return (
      <React.Fragment>
        {step === 1 ? this.stepOneForm() : step === 2 ? this.stepTwoForm() : step === 3 ? this.stepThreeForm() :  this.stepFourForm()}
        {step === 1 ? (
          <ButtonContainer>
            <Main>
              <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto" disabled={!title || !imgSrc || (charCount > 3000)} onClick={!title || !imgSrc || (charCount > 3000) ? null : this.saveStep1}>
                Next
              </CommonButtonPopup>
            </Main>
          </ButtonContainer>
        ) : step === 2 ? (
          <ButtonContainer>
            <div className="wrapper">
              <CommonButtonBorder width="200px" height="48px"

                onClick={() => this.updateStep(1)}
                margin="auto auto auto 0px">
                Back
              </CommonButtonBorder>
              <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto"
                // disabled={isDisabled}
                disabled={isStep2Disabled}
                onClick={isStep2Disabled ? null : this.saveStep2}
              >Next
              </CommonButtonPopup>
            </div>
          </ButtonContainer>
        ) :
          step === 3 ?
            (
              <ButtonContainer>
                <div className="wrapper">
                  <CommonButtonBorder width="200px" height="48px"
                    onClick={() => this.updateStep(2)}
                    margin="auto auto auto 0px">
                    Back
                  </CommonButtonBorder>
                  <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto" onClick={this.saveStep3}>
                    Next
                  </CommonButtonPopup>
                </div>
              </ButtonContainer>
            )  : step === 4 && (
              <ButtonContainer>
                <div className="wrapper">
                  <CommonButtonBorder width="200px" height="48px"
                    onClick={() => this.updateStep(3)}
                    margin="auto auto auto 0px">
                    Back
                  </CommonButtonBorder>
                  <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto" onClick={this.saveStep4}>
                    Create Challenge
                  </CommonButtonPopup>
                </div>
              </ButtonContainer>
            )
        }
      </React.Fragment>
    );
  }
}

CreateLegacyChallengeForm.propTypes = {
  createOndemand: PropTypes.func.isRequired,
  fetchOndemandCategory: PropTypes.func,
  ondemandCategory: PropTypes.array,
  history: PropTypes.object.isRequired,
  t: PropTypes.func,
  fetchOndemandEventDetailsById: PropTypes.func.isRequired,
  ondemandEventDetail: PropTypes.object,
  isEditCategory: PropTypes.object,
  EditOndemandEventVideo: PropTypes.func,
};

export default (withTranslation()(CreateLegacyChallengeForm));